import {
  ORDER_STATES,
  AT_LAUNDRY_STATES,
  OPEN_STATES,
  isAtLaundry,
  isSameDay,
  startOfToday,
} from "../../../services/managerApi";

/**
 * Agrégats de l'Overzicht calculés côté client.
 *
 * Solution transitoire tant que `/customer/manager/dashboard` n'existe pas :
 * on additionne les commandes déjà chargées. Fonction pure et sans dépendance
 * réseau, donc directement testable.
 */

export const countByState = (orders = []) => {
  const counts = ORDER_STATES.reduce((acc, state) => ({ ...acc, [state]: 0 }), {});
  orders.forEach((order) => {
    if (counts[order.state] !== undefined) counts[order.state] += 1;
  });
  return counts;
};

/**
 * États à montrer dans la rail : ceux que WOSH détient, et qui ont au moins une
 * commande. Les afficher tous remplirait l'écran de zéros — `ready_for_shop` ne
 * concerne qu'une commande sur 47 000.
 */
export const activeStates = (counts) =>
  AT_LAUNDRY_STATES.filter((state) => counts[state] > 0);

/** Commandes actuellement chez WOSH, tous états de traitement confondus. */
export const atLaundryOrders = (orders = []) => orders.filter((order) => isAtLaundry(order.state));

export const openOrders = (orders = []) =>
  orders.filter((order) => OPEN_STATES.includes(order.state));




export const monthToDateTotal = (orders = []) => {
  const now = new Date();
  return orders
    .filter((order) => {
      const date = order.pickupDate;
      return (
        date && date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()
      );
    })
    .reduce((sum, order) => sum + (order.total || 0), 0);
};

export const totalKilos = (orders = []) =>
  orders.reduce((sum, order) => sum + (order.kilos || 0), 0);

/**
 * Enlèvements par jour sur les `days` derniers jours, du plus ancien au plus récent.
 * Renvoie toujours `days` entrées, y compris les jours sans activité — sinon le
 * graphe donnerait une fausse impression de régularité.
 */
export const dailyPickups = (orders = [], days = 30) => {
  const today = startOfToday();
  const buckets = [];

  for (let offset = days - 1; offset >= 0; offset -= 1) {
    const date = new Date(today);
    date.setDate(date.getDate() - offset);
    buckets.push({ date, count: 0, isToday: offset === 0 });
  }

  orders.forEach((order) => {
    if (!order.pickupDate) return;
    const bucket = buckets.find((entry) => isSameDay(entry.date, order.pickupDate));
    if (bucket) bucket.count += 1;
  });

  return buckets;
};

/** Construit l'ensemble des agrégats depuis une liste de commandes. */
export const buildOverview = (orders = []) => {
  const open = openOrders(orders);
  const counts = countByState(orders);
  return {
    counts,
    states: activeStates(counts),
    atLaundryCount: atLaundryOrders(orders).length,
    openCount: open.length,
    monthTotal: monthToDateTotal(orders),
    kilos: totalKilos(orders),
    chart: dailyPickups(orders),
  };
};
